import { createAsyncStoragePersister } from "@tanstack/query-async-storage-persister";
import { dmnStorage } from "../utils/dmnStorage";

// Key under which the dehydrated TanStack Query cache snapshot is stored. Kept
// distinct from the per-feature storage keys (venueId, featureFlags, ...) so
// the snapshot never collides with them.
export const QUERY_CACHE_STORAGE_KEY = "collinsQueryCache";

// Exposes dmnStorage through the AsyncStorage shape the persister expects.
// dmnStorage already picks the right backend per platform — localStorage-slim
// in the browser and the AsyncStorage-backed @workspace/mobile store inside the
// React Native WebView (where window.localStorage can be null) — so the
// persisted cache works in both without touching localStorage directly. Values
// are always strings (the persister serialises to JSON), which round-trip
// through both backends.
const dmnAsyncStorage = {
  getItem: async (key: string): Promise<string | null> => {
    const value = await dmnStorage.get(key);
    return typeof value === "string" ? value : null;
  },
  setItem: async (key: string, value: string): Promise<void> => {
    await dmnStorage.add(key, value);
  },
  removeItem: async (key: string): Promise<void> => {
    await dmnStorage.delete(key);
  }
};

// Async storage persister for the app-wide QueryClient. serialize/deserialize
// default to JSON.stringify/JSON.parse, so the whole snapshot is stored as one
// string under QUERY_CACHE_STORAGE_KEY.
export const queryPersister = createAsyncStoragePersister({
  storage: dmnAsyncStorage,
  key: QUERY_CACHE_STORAGE_KEY
});
